import { Order, TestSingularFlat } from "../../types/models";

export const extractTestsNumbers = (order: Order<TestSingularFlat>) => {
  return order.samples
    .reduce<TestSingularFlat[]>((acc, spl) => acc.concat(spl.tests), [])
    .map(t => t.testNumber);
};
